import fetchMock from 'fetch-mock';
import linkInfo from './mockData/linkInformation.json';
import manifest from './mockData/manifest.json';
import senderInfo from './mockData/latestSenderInfo.json';
import { apiDomainResolver } from '../commonUtil/util';
import { URL_HOST } from '../commonUtil/constants';

export default class MockService {
    initialize() {
        this.url = URL_HOST;
        const base = `https://${apiDomainResolver(this.url)}/api/engagement/v1/viewer`;
        const newSession = { sessionId: '7d8ae9f8-cdcc-42e1-af28-a1f50006c612' };

        fetchMock
            .mock(`begin:${base}/mockLinkId`, JSON.stringify(linkInfo), { method: 'GET' })
            .mock(`begin:${base}/manifest/`, JSON.stringify(manifest), { method: 'POST' })
            .mock(`begin:${base}/sender/`, JSON.stringify(senderInfo), { method: 'GET' })
            .mock(`begin:${base}/session/mockLinkId`, JSON.stringify(newSession), { method: 'POST' })
            .mock(`begin:http://${apiDomainResolver(this.url)}/Services/LiveSendServices.svc/SeismicLogEvents`, 200)
            .mock(`begin:https://${apiDomainResolver(this.url)}/Services/LiveSendServices.svc/SeismicLogEvents`, 200);
    }
}
